import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { Image } from "../Image/index.js";
import { PlainA } from "../PlainA/index.js";
import { Span } from "../Text/index.js";
import { getIconSize } from "./Attribute.utils.js";
import { attributeVariants } from "./Attribute.variants.js";
const Attribute_Attribute = /*#__PURE__*/ forwardRef(function({ actionIconName, actionIconText, altText, className, href, iconName, imageUrl, isVertical, size, text, truncate, onClick, slots = {
    root: '',
    imageIconWrapperSlot: '',
    iconSlot: '',
    imageSlot: '',
    textSlot: ''
}, ...rest }, ref) {
    const isActionable = Boolean(href) || Boolean(onClick);
    const showImage = Boolean(imageUrl && altText && !(!isVertical && iconName));
    const { imageIconWrapperSlot, iconSlot, imageSlot, root, textSlot, textWrapperSlot } = attributeVariants({
        hasIcon: Boolean(iconName),
        isActionable,
        isVertical,
        showImage,
        size,
        truncate
    });
    const isSmall = 'sm' === size;
    const rootClasses = cn(root(), className ?? slots.root);
    const imageIconWrapperSlotClasses = cn(imageIconWrapperSlot(), slots.imageIconWrapperSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const imageSlotClasses = cn(imageSlot(), slots.imageSlot);
    const textSlotClasses = cn(textSlot(), slots.textSlot);
    const textWrapperSlotClasses = cn(textWrapperSlot(), slots.textWrapperSlot);
    const iconSize = getIconSize({
        isSmall,
        isVertical,
        showImage
    });
    const horizontalImageSize = isSmall ? 4 : 5;
    const fontSize = isSmall ? 'body3' : 'body2';
    const actionType = href ? 'a' : 'button';
    const Component = isActionable ? actionType : 'div';
    return /*#__PURE__*/ jsxs(Component, {
        ref: ref,
        className: rootClasses,
        onClick: onClick,
        href: href,
        ...rest,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: imageIconWrapperSlotClasses,
                children: [
                    showImage ? /*#__PURE__*/ jsx(Image, {
                        src: imageUrl,
                        alt: altText,
                        borderRadius: isVertical ? 'md' : 'sm',
                        width: 'auto',
                        height: isVertical ? 'full' : horizontalImageSize,
                        className: imageSlotClasses
                    }) : null,
                    iconName ? /*#__PURE__*/ jsx(CdnIcon, {
                        iconName: iconName,
                        size: iconSize,
                        className: iconSlotClasses,
                        title: text
                    }) : null
                ]
            }),
            /*#__PURE__*/ jsxs("div", {
                className: textWrapperSlotClasses,
                children: [
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: fontSize,
                        className: textSlotClasses,
                        children: text
                    }),
                    isActionable && (actionIconName || actionIconText) ? /*#__PURE__*/ jsx(PlainA, {
                        iconLeft: actionIconName,
                        textStyle: fontSize,
                        children: actionIconText
                    }) : null
                ]
            })
        ]
    });
});
export { Attribute_Attribute as Attribute };
